export default __webpack_public_path__ + "static/media/user-icon.153d9e8e.svg";